// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1KP60","row":"ProcedureTreatmentSummary_row__2BII7"};